import React from 'react';

import { getObjectSizes } from '../get-object-sizes';
import { getObjects } from '../get-objects';
import type { ObjectData } from '../types';

import { BaseExplorer } from './base-explorer';

type ObjectExplorerProps = {
	testId?: string;
};

export function ObjectExplorer({ testId }: ObjectExplorerProps): React.JSX.Element {
	return (
		<BaseExplorer<ObjectData>
			testId={testId}
			isObjectTile={false}
			getObjects={getObjects}
			getSizes={getObjectSizes}
		/>
	);
}
